/* eslint-disable prefer-template */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-confusing-arrow */
/* eslint-disable no-plusplus */
/* eslint-disable react/react-in-jsx-scope */
import * as Yup from 'yup';
import DateFormatter from 'components/DateFormatter';
import { FaCheck } from 'react-icons/fa6';
import { currencyToLocal } from 'utils/constants';

export const offerCouponsColumns = [
  { accessorKey: 'code', header: 'COUPON CODE', enableSorting: true },
  {
    accessorKey: 'discountValue',
    header: 'DISCOUNT',
    cell: ({ row }) => (
      <div>{`${
        row?.original?.discountValue
          ? `${row?.original?.discountType === 'FLAT' ? currencyToLocal(row?.original?.discountValue, row?.original?.currency?.id === '233' ? 'USD' : 'INR') : ''}
        ${row?.original?.discountType === 'PERCENTAGE' ? row?.original?.discountValue + '%' : ''}`
          : 'N/A'
      }`}</div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'usageLimit',
    header: 'USAGE LIMIT',
    // cell: ({ row }) => (
    //   <div>
    //     {row?.original?.usageLimit
    //       ? `${row?.original?.usageCount}/${row?.original?.usageLimit}`
    //       : 'Not Available'}
    //   </div>
    // ),
    enableSorting: true,
  },
  {
    accessorKey: 'validity_period',
    header: 'Validity Period',
    cell: ({ row }) => (
      <div className="text-nowrap d-flex align-items-center">
        <DateFormatter dateTime={row?.original?.fromDate} />
        <span className="mx-3">-</span>
        <DateFormatter dateTime={row?.original?.expiryDate} />
      </div>
    ),
    enableSorting: false,
  },

  {
    accessorKey: 'createdAt',
    header: 'CREATED DATE',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
    enableSorting: true,
  },
  {
    accessorKey: 'status',
    header: 'STATUS',
    enableSorting: true,
  },
  // {
  //   accessorKey: 'copy',
  //   header: 'COPY',
  //   enableSorting: false,
  // },
  // {
  //   accessorKey: 'action',
  //   header: '',
  //   enableSorting: false,
  // },
  {
    accessorKey: 'actions',
    header: '',
    enableSorting: false,
  },
];

export const deletedOfferCouponsColumns = [
  { accessorKey: 'code', header: 'COUPON CODE', enableSorting: true },
  {
    accessorKey: 'discountValue',
    header: 'DISCOUNT',
    cell: ({ row }) => (
      <div>{`${
        row?.original?.discountValue
          ? `${row?.original?.discountType === 'FLAT' ? currencyToLocal(row?.original?.discountValue, row?.original?.currency?.id === '233' ? 'USD' : 'INR') : ''}
        ${row?.original?.discountType === 'PERCENTAGE' ? row?.original?.discountValue + '%' : ''}`
          : 'N/A'
      }`}</div>
    ),
    enableSorting: true,
  },
  {
    accessorKey: 'usageLimit',
    header: 'USAGE LIMIT',
    // cell: ({ row }) => (
    //   <div>
    //     {row?.original?.usageLimit
    //       ? `${row?.original?.usageCount}/${row?.original?.usageLimit}`
    //       : 'Not Available'}
    //   </div>
    // ),
    enableSorting: true,
  },
  {
    accessorKey: 'validity_period',
    header: 'Validity Period',
    cell: ({ row }) => (
      <div className="text-nowrap d-flex align-items-center">
        <DateFormatter dateTime={row?.original?.fromDate} />
        <span className="mx-3">-</span>
        <DateFormatter dateTime={row?.original?.expiryDate} />
      </div>
    ),
    enableSorting: false,
  },

  {
    accessorKey: 'createdAt',
    header: 'CREATED DATE',
    cell: ({ row }) => <DateFormatter dateTime={row?.original?.createdAt} />,
    enableSorting: true,
  },
];

export const vendorCouponsColumns = [
  {
    accessorKey: 'trader.firstName',
    header: 'VENDOR',
    enableSorting: false,
    cell: ({ row }) => (
      <div>{`${row?.original?.trader?.firstName} ${row?.original?.trader?.lastName}`}</div>
    ),
  },
  {
    accessorKey: 'trader.phone',
    header: 'Phone Number',
    enableSorting: false,
    cell: ({ row }) => <div>{`${row?.original?.trader?.phone}`}</div>,
  },
  {
    accessorKey: 'emailSentDate',
    header: 'SEND DATE',
    cell: ({ row }) => (
      <DateFormatter dateTime={row?.original?.emailSentDate} />
    ),
    enableSorting: false,
  },
  {
    accessorKey: 'isCouponApplied',
    header: 'Coupon Applied',
    enableSorting: false,
    cell: ({ row }) =>
      row?.original?.isCouponApplied === true ? (
        <span className="coupon-badge font-manrope d-inline-flex align-items-center">
          <FaCheck size={17} className="fw-semibold me-1" color="#3260AB" />{' '}
          Coupon Used
        </span>
      ) : (
        'Not Applied'
      ),
  },
];

export const generateRandomString = () => {
  const capitalAlphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const numbers = '0123456789';

  let randomString = '';

  // Generate first four characters (capital alphabets)
  for (let i = 0; i < 4; i++) {
    randomString += capitalAlphabets.charAt(
      Math.floor(Math.random() * capitalAlphabets.length),
    );
  }

  // Generate remaining characters (numbers)
  for (let i = 0; i < 4; i++) {
    randomString += numbers.charAt(Math.floor(Math.random() * numbers.length));
  }

  return randomString;
};

export const convertDateTimeIntoEpochTime = (datetime) => {
  const date = new Date(datetime);
  const epochTime = date.getTime();
  return epochTime;
};

// Function to convert epoch time to a date string
export const epochToDate = (epoch) => {
  // Create a new Date object with the epoch time in milliseconds
  const date = new Date(epoch);
  // Format the date string
  const options = {
    weekday: 'short',
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    timeZoneName: 'short',
  };

  // console.log("date.toLocaleString('en-US', options)",date.toLocaleString('en-US', options))
  // Return the formatted date string
  return date.toLocaleString('en-US', options);
};

export const couponValidationSchema = Yup.object().shape({
  code: Yup.string()
    .required('Coupon Code is required')
    .min(4, 'Coupon Code must be at least 4 characters')
    .max(10, 'Coupon Code must be at most 10 characters'),
  // discountValue: Yup.number().required('Discount is required'),
  discountValue: Yup.number()
    .required('Discount is required')
    .when('discountType.id', {
      is: 'PERCENTAGE',
      then: (schema) => schema.max(100, 'Discount cannot exceed 100%'),
    }),
  usageLimit: Yup.number()
    .required('Usage Limit is required')
    .max(100, 'Usage Limit must be at most 100'),
  // discountType: Yup.string().required('Discount Type is required'),
  fromDate: Yup.string().required('From Date is required'),
  expiryDate: Yup.string().required('Expiry Date is required'),
});

// export const sharingValidationSchema = Yup.object().shape({
//   status: Yup.array()
//     .min(1, 'Select at least one trader')
//     .required('Status is required'),
// });

export const couponConstants = {
  ALL: 'All',
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
  EXPIRED: 'Expired',
  PLANNED: 'Planned',
  DELETED: 'Deleted',
};
